import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import { initialSelectedGroup } from "./helper";

const initialState = {
  gruppiNumeriNeri: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  createGruppiDiNumeriNeri: {
    data: {
      destinationTypes: [],
      fdnList: [],
      fdnGroupList: [],
      vocalMessagesList: [],
      nedList: [],
      currentItemList: []
    },
    loading: false,
  },
  selectedGroup: initialSelectedGroup,
  createGruppiDiNumeriNeriLoading: false,
  exportGruppiNumeriNeriLoading: false,
};

const setNumeriNeriGruppiData = (state, action) => {
  return updateObject(state, {
    gruppiNumeriNeri: updateObject(state.gruppiNumeriNeri, {
      [action.key]: action.value,
    }),
  });
};

const setCreateGruppiDiNumeriNeriData = (state, action) => {
  return updateObject(state, {
    createGruppiDiNumeriNeri: updateObject(state.createGruppiDiNumeriNeri, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentGroup = (state, action) => {
  return updateObject(state, {
    selectedGroup: updateObject(state.selectedGroup, {
      [action.key]: action.value,
    }),
  });
};

const setExportGruppiNumeriNeriLoading = (state, action) => {
  return updateObject(state, {
    exportGruppiNumeriNeriLoading: action.value,
  });
};

const setCreateGruppiDiNumeriNeriLoading = (state, action) => {
  return updateObject(state, {
    createGruppiDiNumeriNeriLoading: action.value,
  });
};

const gruppiDiNumeriNeriReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_GETSIONI_NUMERI_NERI_GRUPPI_DATA_AND_LOADING:
      return setNumeriNeriGruppiData(state, action);
    case actionTypes.CREATE_GRUPPI_DI_NUMERI_NERI_DATA:
      return setCreateGruppiDiNumeriNeriData(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_GRUPPI_NUMERI_NERI:
      return setCreateGruppiDiNumeriNeriLoading(state, action);
    case actionTypes.GET_CURRENT_GROUP:
      return setCurrentGroup(state, action);
    case actionTypes.EXPORT_GRUPPI_NUMERI_NERI_LOADING:
      return setExportGruppiNumeriNeriLoading(state, action);
    default:
      return state;
  }
};

export default gruppiDiNumeriNeriReducer;
